/**
 * 联盟合伙人相关路由配置
 */
const partnerRoutes = [
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('@/views/partner/PartnerView.vue'),
    meta: {
      title: '联盟合伙人',
      requireAuth: true,
      hideNav: true
    }
  },
  {
    path: '/partner/gift-record',
    name: 'PartnerGiftRecord',
    component: () => import('@/views/partner/PartnerGiftRecordView.vue'),
    meta: {
      title: '黑金合伙人权益卡',
      requireAuth: true,
      hideNav: true
    }
  },
  {
    path: '/partner/incentive',
    name: 'PartnerIncentive',
    component: () => import('@/views/partner/PartnerIncentiveView.vue'),
    meta: {
      title: '共建激励权益',
      requireAuth: true,
      hideNav: true
    }
  }
]

export default partnerRoutes
